export const MAP_SETTINGS_EXPORT_IMAGE_SETTINGS_UPDATE = 'MAP_SETTINGS_EXPORT_IMAGE_SETTINGS_UPDATE';
